import { useWindowDimensions } from 'react-native';
import { isValidBreakpoint } from '../generateStylePropsFromCSSIds';
import { useStyled } from '../StyledProvider';
export const useMedia = () => {
  var _theme$config;
  const theme = useStyled();
  const {
    width
  } = useWindowDimensions();
  const mediaQueries = theme === null || theme === void 0 || (_theme$config = theme.config) === null || _theme$config === void 0 || (_theme$config = _theme$config.tokens) === null || _theme$config === void 0 ? void 0 : _theme$config.mediaQueries;
  const breakpoints = {};
  Object.keys(mediaQueries).forEach(currentBreakPoint => {
    breakpoints[currentBreakPoint] = isValidBreakpoint(theme === null || theme === void 0 ? void 0 : theme.config, mediaQueries[currentBreakPoint], width);
  });
  return breakpoints;
};
//# sourceMappingURL=useMedia.js.map